export default __webpack_public_path__ + "static/augmented-reality-ae4d04d9036682e78f22ad6a4feeeece.png";